module.exports = __webpack_public_path__ + "static/media/twint_web.76fedf2b.svg";